import * as types from './actionTypes'

export function startReciveVideos() {
  return { type: types.BEGIN_FETCH_VIDEOS }
}
export function finishReciveVideos() {
  return { type: types.FINISH_FETCH_VIDEOS }
}

export function reciveVideos(videos, folderName) {
  return { type: types.FETCH_VIDEOS, videos, folderName }
}

export function fetchVideos(videos, folderName) {
  return (dispatch) => {
    dispatch(startReciveVideos())
    dispatch(reciveVideos(videos, folderName))
    dispatch(finishReciveVideos())
  }
}
